module.exports = __webpack_public_path__ + "static/media/ratings.ebbf491f.svg";